import { render, staticRenderFns } from "./s-icons.vue?vue&type=template&id=6109c048&scoped=true&"
import script from "./s-icons.vue?vue&type=script&lang=js&"
export * from "./s-icons.vue?vue&type=script&lang=js&"
import style0 from "./s-icons.vue?vue&type=style&index=0&id=6109c048&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6109c048",
  null
  
)

export default component.exports